import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { VoteIdeaInput, VoteIdeaOutput } from "types/web-app";

export const voteIdea = async (accessToken: string, input: VoteIdeaInput) => {
  try {
    const response = await fetchWithAuth("/ideas/vote", accessToken, {
      method: "POST",
      body: JSON.stringify(input),
    });
    const data = (await response.json()) as ServiceResponse<VoteIdeaOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
